import { render, staticRenderFns } from "./bind_account.vue?vue&type=template&id=158ec6df"
import script from "./bind_account.vue?vue&type=script&lang=js"
export * from "./bind_account.vue?vue&type=script&lang=js"
import style0 from "./bind_account.vue?vue&type=style&index=0&id=158ec6df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports